export const chiknMetaData = {}